import Manage from "../types/manage";
import axios from "../utils/axios";

export const editServicePackageGroup = (id: string, request: Manage.ServicePackages.Groups.EditRequest) => {
  return axios.put(`/api/v1/servicepackagegroups/${id}`, { ...request });
}
